import PropTypes from 'prop-types';

export default function AuthLayout({ children }) {
  return children;
  // return (
  //   <Wrapper>
  //     <Content>{children}</Content>
  //   </Wrapper>
  // );
}

AuthLayout.propTypes = {
  children: PropTypes.element.isRequired,
};
